export default __webpack_public_path__ + "static/media/tv_light.e2300a0e.png";